import { render } from "./AdminHeader.vue?vue&type=template&id=3f5c0aee&scoped=true"
import script from "./AdminHeader.vue?vue&type=script&lang=js"
export * from "./AdminHeader.vue?vue&type=script&lang=js"

import "./AdminHeader.vue?vue&type=style&index=0&id=3f5c0aee&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f5c0aee"]])

export default __exports__